module.exports = __webpack_public_path__ + "img/img01.8dab96c3.png";